import { render, staticRenderFns } from "./wxPay.vue?vue&type=template&id=0b40e1a0&scoped=true&"
import script from "./wxPay.vue?vue&type=script&lang=js&"
export * from "./wxPay.vue?vue&type=script&lang=js&"
import style0 from "./wxPay.vue?vue&type=style&index=0&id=0b40e1a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b40e1a0",
  null
  
)

export default component.exports